export const tippyFakeInstance = {
  clearDelayTimeouts: () => {},
  destroy: () => {},
  disable: () => {},
  enable: () => {},
  hide: () => {},
  hideWithInteractivity: () => {},
  id: 0,
  plugins: [
    {
      name: 'followCursor',
      defaultValue: false,
    },
  ],
  popper: {
    state: {},
  },
  popperInstance: {},
  props: {},
  reference: {},
  setContent: () => {},
  setProps: () => {},
  show: () => {},
  state: {
    isEnabled: true,
    isVisible: true,
    isDestroyed: false,
    isMounted: true,
    isShown: false,
  },
  unmount: () => {},
};
